import React from 'react';
import { Flex, Text, Palette } from '@updater/ui-uds';
import { ChatInterface } from './ChatInterface';
import { useVirtualAssistantChatReturn } from 'flows/virtual-building-assistant/hooks/useVirtualAssistantChat';

export interface ChatReadinessGateProps {
  uiState: useVirtualAssistantChatReturn['chatComponentProps']['uiState'];
  data: useVirtualAssistantChatReturn['chatComponentProps']['data'];
  stableHandleSendMessageWithTracking: (msg: string, files?: File[]) => void;
  stableOnTypewriterDone: () => void;
}

export const ChatReadinessGate = React.memo((props: ChatReadinessGateProps) => {
  const {
    uiState,
    data,
    stableHandleSendMessageWithTracking,
    stableOnTypewriterDone,
  } = props;
  const shouldRenderChat =
    uiState.chatReadyState === 'ready' &&
    data.messages !== undefined &&
    data.validConversation !== undefined;

  if (!shouldRenderChat) {
    return (
      <Flex
        key="chat-loading"
        alignItems="center"
        justifyContent="center"
        flex="1"
        opacity={0.7}
      >
        <Text color={Palette.white} variant="xs">
          {uiState.chatReadyState === 'ready'
            ? 'Loading conversation data...'
            : uiState.chatReadyState === 'loading'
            ? 'Preparing chat interface...'
            : 'Initializing chat...'}
        </Text>
      </Flex>
    );
  }

  return (
    <ChatInterface
      key="chat-ready-stable"
      ref={data.chatRef}
      placeholder="Ask me anything..."
      onSendMessage={stableHandleSendMessageWithTracking}
      isLoading={data.isLoading}
      loadingMessage="Assistant is typing..."
      messages={data.messages}
      enableScrollBehavior={true}
      animateLastAssistant={data.animateLastAssistant}
      onTypewriterDone={stableOnTypewriterDone}
    />
  );
});

export default ChatReadinessGate;
